import React, { createContext, useCallback, useContext, useRef, useState } from 'react'

export interface CampaignDetailsEditActions {
  save: () => Promise<void>
  discard: () => void
}

interface CampaignDetailsEditContextValue {
  hasUnsavedChanges: boolean
  canSaveChanges: boolean
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void
  setCanSaveChanges: (canSaveChanges: boolean) => void
  setActions: (actions: CampaignDetailsEditActions | null) => void
  saveChanges: () => Promise<void>
  discardChanges: () => void
}

const noop = () => {}
const noopAsync = async () => {}

const detachedValue: CampaignDetailsEditContextValue = {
  hasUnsavedChanges: false,
  canSaveChanges: true,
  setHasUnsavedChanges: noop,
  setCanSaveChanges: noop,
  setActions: noop,
  saveChanges: noopAsync,
  discardChanges: noop
}

const CampaignDetailsEditContext = createContext<CampaignDetailsEditContextValue>(detachedValue)

export const CampaignDetailsEditProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const actionsRef = useRef<CampaignDetailsEditActions | null>(null)
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false)
  const [canSaveChanges, setCanSaveChanges] = useState(true)

  const setActions = useCallback((actions: CampaignDetailsEditActions | null) => {
    actionsRef.current = actions
  }, [])

  const saveChanges = useCallback(async () => {
    await actionsRef.current?.save()
  }, [])

  const discardChanges = useCallback(() => {
    actionsRef.current?.discard()
  }, [])

  return <CampaignDetailsEditContext.Provider value={{ hasUnsavedChanges, canSaveChanges, setHasUnsavedChanges, setCanSaveChanges, setActions, saveChanges, discardChanges }}>{children}</CampaignDetailsEditContext.Provider>
}

export const useCampaignDetailsEdit = () => useContext(CampaignDetailsEditContext)
